module.exports = __webpack_public_path__ + "static/media/mode-2043.e4eb0b17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2043.svg
// module id = 1054
// module chunks = 2